import type { HTMLAttributes } from 'react';
import type { Content, CouponType } from './coupon-detail/coupon-detail.types';

export type CouponCardType = 'voucher' | 'eWalletVoucher';
export interface CouponInformationProps {
    coupon: CouponType;
    content?: Content;
    handleAgree?: () => void;
    label?: string;
    labelCouponCard: string;
    expiredLabel: string;
    className?: HTMLAttributes<HTMLElement>['className'];
    variant?: CouponCardType;
    hasShowProgress?: boolean;
}

export const CouponInformationTestId = {
    CONTAINER: 'coupon-information-container',
    FLAT_LIST: 'coupon-information-flat-list',
    HEADER_BACKGROUND: 'coupon-information-header-background',
    COUPON_CARD_VIEW: 'coupon-information-coupon-card-view',
    DETAIL_CONTAINER: 'coupon-information-detail-container',
    AGREE_BUTTON: 'coupon-information-agree-button',
};
